/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorPatientChatBubble.vue?vue&type=template&id=9ba5177a&scoped=true"
import script from "./DoctorPatientChatBubble.vue?vue&type=script&lang=js"
export * from "./DoctorPatientChatBubble.vue?vue&type=script&lang=js"
import style0 from "./DoctorPatientChatBubble.vue?vue&type=style&index=0&id=9ba5177a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba5177a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba5177a')) {
      api.createRecord('9ba5177a', component.options)
    } else {
      api.reload('9ba5177a', component.options)
    }
    module.hot.accept("./DoctorPatientChatBubble.vue?vue&type=template&id=9ba5177a&scoped=true", function () {
      api.rerender('9ba5177a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/DoctorPatientChatBubble.vue"
export default component.exports